export default __webpack_public_path__ + "static/media/loadingIcon.d4d1d90d.gif";